import apiService from '@/state/services/Api'

const demoCreator = {
  namespaced: true,
  state: {
    cached: [],
  },
  getters: {},
  actions: {
    create({ state, commit, rootState }, {}) {
      //email, password, company (name), points ([(x,y)...])
      return apiService.post(`generate-readouts/`, {})
    },
  }
}

export default demoCreator
